const name = process.env.REACT_APP_NAME || '';

export const SCRIPT_ID = process.env.REACT_APP_SCRIPT_ID || '';
export const ENV = process.env.REACT_APP_ENV || 'MOCK';

const IS_LIVE = process.env.STORYBOOK_BUILD_ENV === 'live';
const IS_TEST_ENV = process.env.REACT_APP_ENV === 'TEST';

export const VERSION = process.env.REACT_APP_VERSION || '';

export const SERVICE_WORKER_SCOPE = 'http://localhost:3000/';

function getStorybookStaticOrigin() {
	if (IS_TEST_ENV) {
		return 'http://localhost';
	}

	if (IS_LIVE) {
		return process.env.REACT_APP_STORYBOOK_LIVE_URL;
	}

	return `${process.env.REACT_APP_STORYBOOK_URL}/${name}/${VERSION}/sb`;
}

export const STORYBOOK_STATIC_ORIGIN = getStorybookStaticOrigin();

export const API_URL_WEBCX =
	process.env.REACT_APP_API_URL_WEBCX ||
	'https://64375e530c58d3b1456fff2b.mockapi.io';

export const REDIRECT_HOST =
	process.env.REACT_APP_REDIRECT_HOST ||
	'https://stg-cdn.rmc.contents.rakuten.co.jp/sdk/webcx-redirect-module/1.4.0/index.html';

export const STORY_MAIN_FOLDER = 'api';

export const API_URL_EVENT_LOGGER =
	process.env.REACT_APP_API_URL_EVENT_LOGGER ||
	'https://gateway-api.intra.rakuten-it.com/svcobs/api/v1/external/logging/error';

export const API_KEY_EVENT_LOGGER =
	process.env.REACT_APP_API_KEY_EVENT_LOGGER || '';

export const RAT_PROJECT_KEY = 'RMCCX_BLOCKS';

export const API_URL_CAMPAIGNS_CONFIG =
	process.env.REACT_APP_API_URL_CAMPAIGNS_CONFIG ||
	'https://stg-cdn.rmc.contents.rakuten.co.jp';

export const THROTTLE_TIMEOUT = 50;

// NOTE: In case the localstorage schema is changed the storage version should be increased
// NOTE: It's required to avoid issue in case localstorage schema will be updated
// NOTE: The app version can't be used since it will produce to much keys in localstorage
// NOTE: As well it will not allow to keep storage data between FE versions
const LOCALSTORAGE_VERSION = 'STORAGE_1.3.0';

export const LOCAL_STORAGE_KEY = `RMCCX_BLOCKS_${LOCALSTORAGE_VERSION}`;
export const LEGACY_LOCAL_STORAGE_KEY = 'RMCCX_BLOCKS_STORAGE_1.1.0';

export const LOGGER_KEY = 'rmc-web-cx-web-blocks';
export const CAMPAIGNS_JSON_FILE_NAME = 'blocks';
export const API_MAIN_ENDPOINT = 'blocks';
